import { render, staticRenderFns } from "./PersistentFooter.vue?vue&type=template&id=0481af94&scoped=true&"
import script from "./PersistentFooter.vue?vue&type=script&lang=js&"
export * from "./PersistentFooter.vue?vue&type=script&lang=js&"
import style0 from "./PersistentFooter.vue?vue&type=style&index=0&id=0481af94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0481af94",
  null
  
)

export default component.exports